import { ComponentWithTooltip } from 'components/ComponentWithTooltip';
import type { WorkOrderOtherPriceData } from 'gql/graphql';
import { WorkOrderStatusEnum, ChapterEnum } from 'gql/graphql';
import { Checkbox, Loader } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import type React from 'react';

import { WorkOrderRowMenu } from '../../WorkorderRowMenu';
import { checkActKC2OtherHaveNoZeroPrices } from '../checkActKC2OtherHaveNoZeroPrices';
import { checkIsDisabledByWorkOrderStatus } from '../checkIsDisabledByWorkOrderStatus';

interface IOtherAgMenuCellRendererComponent extends ICellRendererParams {
    workOrderStatus: WorkOrderStatusEnum | undefined;
    checkedIds: Record<string, boolean>;
    handleChangeCheckbox: (rowId: number) => ({ checked }: { checked: boolean }) => void;
    isContractStatusWork: boolean;
    isDisabledByProjectStatus: boolean | undefined;
    hasActs: boolean;
}

export const OtherAgMenuCellRendererComponent: React.FC<IOtherAgMenuCellRendererComponent> = (props) => {
    const {
        workOrderStatus,
        checkedIds,
        handleChangeCheckbox,
        isContractStatusWork,
        isDisabledByProjectStatus,
        hasActs,
        data,
    } = props;

    if (data === undefined) {
        return <Loader />;
    }

    if ('isGroupTitle' in data && data.isGroupTitle) {
        return <div />;
    }

    const row = data as WorkOrderOtherPriceData;

    const disabledByWorkOrderStatus = checkIsDisabledByWorkOrderStatus(workOrderStatus, row?.isActKC2Price);

    const actKC2OtherHasNoZeroPrices = checkActKC2OtherHaveNoZeroPrices(row);

    const isShowTooltip = !row.hasEmptyActAcceptedCost || !row.hasEmptyActPlanCost;

    const isNotShowTooltipText =
        workOrderStatus === WorkOrderStatusEnum.Completed || workOrderStatus === WorkOrderStatusEnum.Delayed;

    const tooltipText = isNotShowTooltipText
        ? null
        : 'Имеется фактическое выполнение. Для того, чтобы удалить строку необходимо очистить значения в ячейках Акта';

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {isShowTooltip ? (
                <ComponentWithTooltip tooltipText={tooltipText}>
                    <Checkbox
                        checked={checkedIds[row.id]}
                        onChange={handleChangeCheckbox(row.id)}
                        disabled={
                            !isContractStatusWork ||
                            disabledByWorkOrderStatus ||
                            actKC2OtherHasNoZeroPrices ||
                            isDisabledByProjectStatus ||
                            isShowTooltip
                        }
                    />
                </ComponentWithTooltip>
            ) : (
                <Checkbox
                    checked={checkedIds[row.id]}
                    onChange={handleChangeCheckbox(row.id)}
                    disabled={
                        !isContractStatusWork ||
                        disabledByWorkOrderStatus ||
                        actKC2OtherHasNoZeroPrices ||
                        isDisabledByProjectStatus
                    }
                />
            )}
            {'type' in data && data.type && (
                <WorkOrderRowMenu
                    row={data}
                    hasActs={hasActs}
                    workOrderStatus={workOrderStatus}
                    chapter={ChapterEnum.Others}
                    actsData={[]}
                />
            )}
        </div>
    );
};

OtherAgMenuCellRendererComponent.displayName = 'OtherAgMenuCellRendererComponent';
